module.exports = __webpack_public_path__ + "static/media/sdp.961f7ace.jpg";